import { createAction } from 'typesafe-actions';
import { SignInState } from './SignInState';
import { signIn, signOut } from './Action/Login';
import { PlatformErrorCode } from '../../Constants/Platform';

export enum PlatformActionType {
    SET_SIGN_IN_STATE = 'setSignInState',
    SIGN_OUT_PROMPT = 'signOutPrompt',
    SIGN_IN_FAIL = 'signInFail',
    SIGN_IN_SUCCESS = 'signInSuccess',
}

export const PlatformActions = {
    signIn,
    signOut,
    signOutPrompt: createAction(PlatformActionType.SIGN_OUT_PROMPT),
    signInFail: createAction(
        PlatformActionType.SIGN_IN_FAIL,
        resolve => (errorCode: PlatformErrorCode = PlatformErrorCode.NONE) =>
            resolve<PlatformErrorCode>(errorCode)
    ),
    setSignInState: createAction(
        PlatformActionType.SET_SIGN_IN_STATE,
        resolve => (state: SignInState) => resolve<SignInState>(state)
    ),
    signInSuccess: createAction(PlatformActionType.SIGN_IN_SUCCESS),
};
